import React from 'react'
import { DownloadAll } from 'components/Buttons/Buttons'

class DesktopMenu extends React.Component {
    render() {
        return (
            <ul className="menu">
                <li><a id="download-smartphone" href="https://github.com/selfishprimate/sketchize/raw/master/tools/zipped-files/smartphone.zip">SMARTPHONE</a></li>
                <li><a id="download-tablet" href="https://github.com/selfishprimate/sketchize/raw/master/tools/zipped-files/tablet.zip">TABLET</a></li>
                <li><a id="download-browser" href="https://github.com/selfishprimate/sketchize/raw/master/tools/zipped-files/browser.zip">BROWSER</a></li>
                <li><a id="download-sketchpad" href="https://github.com/selfishprimate/sketchize/raw/master/tools/zipped-files/sketchpad.zip">SKETCHPAD</a></li>
                <DownloadAll clickid="download-all" link={"https://github.com/selfishprimate/sketchize/raw/master/tools/zipped-files/sketchize-all.zip"} content="DOWNLOAD ALL" />
            </ul>
        );
    }
}

class MobileMenu extends React.Component {
    render() {
        return (
            <ul className="menu">
                <li><a id="download-smartphone" href="https://github.com/selfishprimate/sketchize/raw/master/tools/single-pdf-files/smartphone.pdf">SMARTPHONE</a></li>
                <li><a id="download-tablet" href="https://github.com/selfishprimate/sketchize/raw/master/tools/single-pdf-files/tablet.pdf">TABLET</a></li>
                <li><a id="download-browser" href="https://github.com/selfishprimate/sketchize/raw/master/tools/single-pdf-files/browser.pdf">BROWSER</a></li>
                <li><a id="download-sketchpad" href="https://github.com/selfishprimate/sketchize/raw/master/tools/single-pdf-files/sketchpad.pdf">SKETCHPAD</a></li>
                <DownloadAll clickid="download-all" link={"https://github.com/selfishprimate/sketchize/raw/master/tools/single-pdf-files/sketchize-all.pdf"} content="DOWNLOAD ALL" />
            </ul>
        );
    }
}

export { DesktopMenu, MobileMenu }



// WEBPACK FOOTER //
// ./src/components/MainMenu/MainMenu.js